import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import PlaneAndOcean from './PlaneAndOcean.tsx';

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  <React.StrictMode>
    <PlaneAndOcean />
  </React.StrictMode>
);

